import React from "react";
import Navbar from "./components/Navbar";

const Header = () => {
  return (
    <>
      <Navbar />
    </>
  );
};

export default Header;
